// extracted by mini-css-extract-plugin
export default {"cardNumber":"AddCardForm_cardNumber__QpM4m","inputsRow":"AddCardForm_inputsRow__Mu1X0","form":"AddCardForm_form__w8bDM","actions":"AddCardForm_actions__NvOuK"};